import { useState } from 'react';

import { useInfiniteQuery } from 'react-query';

import { getAttendEvents } from '@api/attend';
import type { GetAttendEventsQuery } from '@api/attend/getAttendEvents';

function useGetAttendEvents(props?: Partial<GetAttendEventsQuery>) {
  const [total, setTotal] = useState<number>(0);

  const response = useInfiniteQuery(
    [
      'ATTEND_EVENTS',
      props?.page,
      props?.dir,
      props?.q,
      //   props?.name,
      //   props?.startDate,
      //   props?.endDate,
    ],
    async ({ pageParam: page = 1 }) => {
      const query: GetAttendEventsQuery = {
        page,
        limit: 100,
        dir: 'desc',
        ...props,
      };

      const response = await getAttendEvents({ query });

      console.log({ response });

      if (response) setTotal(response.count);

      return response;
    },
    {
      getNextPageParam: (_, pageParam) => {
        const result = pageParam.length + 1;
        return result;
      },
      getPreviousPageParam: (_, pageParam) => {
        const result = pageParam.length - 1;
        return result || 1;
      },
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
      retry: 1,
    },
  );

  const data =
    response.data?.pages?.filter(v => v)?.flatMap(data => (data ? data?.rows?.map(v => v) : [])) ||
    [];

  return { ...response, data, total };
}

export default useGetAttendEvents;
